import React from 'react';
import { TipContainer, TipIcon, TipText } from './FooterTip.styled';

export interface FooterTipProps {
  tipText: string;
  tipType: 'tip' | 'error';
}

export const FooterTip = ({ tipText, tipType }: FooterTipProps) => {
  return (
    <TipContainer tipType={tipType}>
      {tipType === 'tip' && <TipIcon className={'icon-lightbulb'}/>}
      <TipText>
        {tipText}
      </TipText>
    </TipContainer>
  );
};
